import {createSvgIcon} from '../create-svg-icon';

export const RoomPreferencesIcon = createSvgIcon(
  <path d="m21.69 16.37 1.14-1-1-1.73-1.45.49c-.32-.27-.68-.48-1.08-.63L19 12h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49-1 1.73 1.14 1c-.08.5-.08.76 0 1.26l-1.14 1 1 1.73 1.45-.49c.32.27.68.48 1.08.63L17 22h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49 1-1.73-1.14-1c.08-.51.08-.77 0-1.27zM18 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm1-15v6h-2V6h-2v6h-2V5H7v14h5v2H3v-2h2V3h10v1h4zm-7 9h-2v-2h2v2z" />
, 'RoomPreferencesOutlined');
